export const list = {
  table: {
    id: 'ID',
    name: 'Name',
    type: 'Type',
    typeName: 'Type Name',
    status: 'Status',
    finishedTime: 'Finished Time',
    startedTime: 'Started Time',
    working: {
      idle: 'idle',
      inService: 'inService',
    },
    maintain: 'Maintain',
  },
  pageHeader: {
    title: 'Machines',
    titleMachinesList: 'Personal data registration/editing',
    new: 'New',
    import: 'Import Washing Machine',
    importTank: 'Import Tank to Washing Machine',
  },
}
